<template>
  <div>
    <KTCodePreview v-bind:title="'Thông tin phiếu PO chia hàng'">
      <!-- PO tổng (chia hàng) là bản ghi gom nhóm trơ — không còn action workflow. -->
      <template v-slot:preview>
        <b-card no-body class="full-width">
          <div>
            <div
              class="wizard wizard-4"
              id="kt_wizard_v4"
              data-wizard-state="step-first"
              data-wizard-clickable="true"
            >
              <!--begin: Wizard Nav-->
              <div class="wizard-nav" style="background-color: #eef0f8">
                <div class="wizard-steps">
                  <div
                    class="wizard-step"
                    data-wizard-type="step"
                    data-wizard-state="current"
                  >
                    <div class="wizard-wrapper">
                      <div class="wizard-label">
                        <div class="wizard-title">Thông tin</div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >
                    <div class="wizard-wrapper">
                      <div class="wizard-label">
                        <div class="wizard-title">Tệp đính kèm</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-custom card-shadowless rounded-top-0">
                <div class="card-body p-0">
                  <div class="row">
                    <div class="col-xl-12">
                      <div
                        class="py-8 px-4 py-lg-15 px-lg-4 pb-5 full-width"
                        data-wizard-type="step-content"
                        data-wizard-state="current"
                      >
                        <b-row class="mb-5">
                          <!-- INFO INPUT CONTROLS -->
                          <b-col lg="6" md="6" sm="12">
                            <b-row v-if="mainModel.id">
                              <b-col lg="6" md="6" sm="12">
                                <b-form-group>
                                  <template>
                                    <span>Mã phiếu:</span>
                                  </template>
                                  <p class="mt-2">{{ mainModel.code }}</p>
                                </b-form-group>
                              </b-col>
                              <b-col lg="6" md="6" sm="12">
                                <b-form-group>
                                  <template>
                                    <span>Người tạo:</span>
                                  </template>
                                  <p class="mt-2">{{ mainModel.createdBy }}</p>
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="6" md="6" sm="12">
                                <b-form-group>
                                  <template>
                                    <span>Ngày tạo:</span>
                                  </template>
                                  <p class="mt-2">{{ mainModel.createdAt }}</p>
                                </b-form-group>
                              </b-col>
                              <b-col lg="6" md="6" sm="12">
                                <b-form-group>
                                  <template>
                                    <span>Tổng tiền:</span>
                                  </template>
                                  <p class="mt-2">
                                    {{ convertPrice(totalPrice) }}
                                  </p>
                                </b-form-group>
                              </b-col>
                            </b-row>

                            <b-row>
                              <b-col md="6">
                                <b-form-group class="required-control">
                                  <label>Nhà cung cấp:</label>
                                  <div class="float-right">
                                    <span
                                      @click="
                                        showProviderModal = !showProviderModal
                                      "
                                      ><i
                                        class="fa fa-plus-circle text-primary pt-1"
                                        style="cursor: pointer"
                                      ></i
                                    ></span>
                                  </div>
                                  <Autosuggest
                                    class="border-radius-none"
                                    :model="mainModel.providerName"
                                    :suggestions="filteredOptionsProvider"
                                    placeholder="nhà cung cấp"
                                    :limit="200"
                                    @select="onSelectedProvider"
                                    @change="onInputChangeProvider"
                                    suggestionName="suggestionName"
                                    :disabled="isLocked"
                                  />
                                </b-form-group>
                              </b-col>
                            </b-row>

                            <b-row>
                              <b-col lg="12" md="12" sm="12">
                                <b-form-group :disabled="isLocked">
                                  <label>Lý do nhập hàng:</label>
                                  <b-form-textarea
                                    size="sm"
                                    v-model="mainModel.importReason"
                                    :placeholder="'Nhập lý do nhập hàng...'"
                                    :rows="6"
                                    :max-rows="6"
                                  ></b-form-textarea>
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="12" md="12" sm="12">
                                <b-form-group :disabled="isLocked">
                                  <label>Ghi chú:</label>
                                  <b-form-textarea
                                    size="sm"
                                    v-model="mainModel.description"
                                    :placeholder="'Thêm nội dung ghi chú...'"
                                    :rows="6"
                                    :max-rows="6"
                                  ></b-form-textarea>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>
                          <!-- INFO VAT INPUT CONTROLS -->
                          <b-col lg="3" md="3" sm="12">
                            <b-form-group :disabled="!editable">
                              <label>Hình thức thanh toán:</label>
                              <b-form-select
                                class="select-style"
                                v-model="mainModel.type"
                                :options="listImportType"
                                size="sm"
                                value-field="id"
                                text-field="name"
                              >
                              </b-form-select>
                            </b-form-group>
                            <b-form-group :disabled="!editable">
                              <label style="margin-bottom: 0.75rem"
                                >Chiết khấu:</label
                              >
                              <b-row>
                                <b-col class="pr-0" cols="5">
                                  <b-form-select
                                    class="select-style"
                                    v-model="mainModel.discountType"
                                    :options="listAmountType"
                                    size="sm"
                                    value-field="id"
                                    text-field="name"
                                  >
                                  </b-form-select>
                                </b-col>
                                <b-col class="pl-0" cols="7">
                                  <b-form-input
                                    class="input-style text-right"
                                    size="sm"
                                    v-model="mainModel.discountValue"
                                    v-mask="formater.currency"
                                    placeholder="Chiết khấu"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-form-group>

                            <POVat
                              :editable="!isLocked"
                              :mainModel="mainModel"
                            />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="3">
                            <b-form-group :disabled="!editable">
                              <label>Người liên hệ:</label>
                              <Autosuggest
                                class="border-radius-none"
                                :model="searchEmployee"
                                :suggestions="filteredOptionsEmployee"
                                placeholder="người liên hệ"
                                :limit="10"
                                @select="onSelectedEmployee"
                                @change="onInputChangeEmployee"
                                suggestionName="suggestionName"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row class="mb-4" v-if="editable">
                          <b-col lg="2" md="2" sm="12" class="pr-0">
                            <b-form-select
                              v-model="selectTypeSearch"
                              :options="listTypeSearch"
                              size="sm"
                              value-field="id"
                              text-field="name"
                            ></b-form-select>
                          </b-col>
                          <b-col lg="6" md="6" sm="12" class="pl-0 pr-0">
                            <treeselect
                              :load-options="loadOptions"
                              :multiple="true"
                              :async="true"
                              placeholder="Tìm kiếm theo tên, mã, mã vạch sản phẩm"
                              retryText="Thử lại..."
                              retryTitle="Nhấp thử lại"
                              searchPromptText="Nhập để tìm kiếm..."
                              loadingText="Đang tải..."
                              noResultsText="Không có kết quả"
                              :match-keys="['label', 'customLabel']"
                              v-model="selectedProducts"
                              :values="searchProduct"
                              :backspace-removes="false"
                              :clearable="false"
                              valueFormat="object"
                              :max-height="200"
                              :disabled="isLocked"
                              @select="onSelectedProduct"
                            >
                              <label
                                slot="option-label"
                                slot-scope="{ node, labelClassName }"
                                :class="labelClassName"
                                class="border-bottom"
                              >
                                <span
                                  class="text-primary d-block px-0"
                                  v-if="node.raw.label"
                                >
                                  {{ node.raw.label }}
                                </span>
                                <b
                                  v-if="node.raw.customLabel"
                                  class="d-block px-0"
                                >
                                  {{ node.raw.customLabel }}</b
                                >
                              </label>
                            </treeselect>
                          </b-col>
                          <b-col md="1">
                            <b-button
                              style="width: 40px"
                              variant="secondary"
                              size="sm"
                              v-b-tooltip.hover
                              title="Thêm sản phẩm"
                              @click="onAddProduct"
                              :disabled="isLocked"
                            >
                              <i class="fas fa-arrow-down"></i>
                            </b-button>
                          </b-col>
                          <b-col md="3" v-if="!mainModel.id">
                            <div
                              class="d-flex justify-content-end"
                              v-if="!listProduct.length"
                            >
                              <b-button
                                variant="secondary"
                                size="sm"
                                class="font-weight-bolder"
                                @click="showModalImportProduct"
                                v-if="editable"
                              >
                                <i
                                  style="font-size: 1rem"
                                  class="far fa-file-excel"
                                ></i
                                >Nhập SP từ excel
                              </b-button>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="8">
                            <span class="font-weight-bolder lable-size"
                              >Danh sách sản phẩm:</span
                            >
                          </b-col>
                          <b-col md="4">
                            <b-checkbox
                              v-model="mainModel.isVAT"
                              class="d-flex justify-content-end lable-size"
                              @change="onChangeVat"
                              >Đơn giá đã bao gồm VAT
                            </b-checkbox>
                          </b-col>
                        </b-row>
                        <b-table
                          :fields="fieldProduct"
                          :items="listProduct"
                          v-if="renderComponent"
                          hover
                          bordered
                          class="mt-4"
                        >
                          <template v-slot:cell(productName)="row">
                            <span
                              v-text="row.item.productCode"
                              style="font-size: 12px"
                              v-show="row.item.productCode"
                            ></span>
                            <br />
                            <span
                              v-text="row.item.productName"
                              style="white-space: normal; color: #3699ff"
                            ></span>
                            <br />
                            <span
                              class="badge badge-light-primary"
                              style="font-size: 10px"
                            >
                              Tồn kho: {{ row.item.inStockQuantity || 0 }}
                            </span>
                          </template>
                          <template v-slot:cell(unitPrice)="row">
                            <span
                              v-if="
                                mainModel.status ===
                                PURCHASE_ORDER_STATUS.ACCOUNTANT
                              "
                              >{{ convertPrice(row.item.unitPrice) }}</span
                            >
                            <b-input
                              v-else
                              type="text"
                              size="sm"
                              class="input-style text-right"
                              v-model="row.item.unitPrice"
                              v-mask="formater.currency"
                            ></b-input>
                          </template>
                          <template v-slot:cell(salePrice)="row">
                            <span
                              v-if="
                                mainModel.status ===
                                PURCHASE_ORDER_STATUS.ACCOUNTANT
                              "
                              >{{ convertPrice(row.item.salePrice) }}</span
                            >
                            <b-input
                              v-else
                              type="text"
                              size="sm"
                              class="input-style text-right"
                              v-model="row.item.salePrice"
                              v-mask="formater.currency"
                            ></b-input>
                          </template>
                          <template v-slot:cell(actions)="row">
                            <v-icon
                              small
                              class="text-danger text-center"
                              @click="deleteItemInArray(row.item.productId)"
                              v-b-tooltip
                              title="Xóa"
                              >mdi-delete</v-icon
                            >
                          </template>
                        </b-table>
                        <hr
                          class="hr-text"
                          data-content="Danh sách chia hàng"
                          style="font-weight: 600"
                        />
                        <b-row class="mb-4" v-if="editable">
                          <b-col lg="4" md="4" sm="8" class="pr-0">
                            <treeselect
                              :options="stores"
                              v-model="selectedStores"
                              :multiple="true"
                              :normalizer="normalizer"
                              :backspace-removes="false"
                              placeholder="Chọn kho để thêm vào danh sách chia hàng"
                              :max-height="200"
                              noResultsText="Không tìm thấy kết quả"
                              valueFormat="object"
                              :clearable="false"
                              :disabled="listProduct.length === 0 || isLocked"
                            ></treeselect>
                          </b-col>
                          <b-col lg="2" md="2" sm="4">
                            <b-button
                              variant="primary"
                              size="sm"
                              class="font-weight-bolder"
                              @click="onAddStore"
                              :disabled="
                                selectedStores.length === 0 || isLocked
                              "
                            >
                              <i class="fas fa-plus"></i> Thêm kho
                            </b-button>
                          </b-col>
                        </b-row>
                        <b-table
                          :fields="fieldStores"
                          :items="inventories"
                          v-if="renderComponent"
                          hover
                          bordered
                          class="mt-4 col-md-8 inventory-table"
                          :tbody-tr-class="inventoryRowClass"
                          @row-clicked="onInventoryRowClicked"
                        >
                          <template v-slot:cell(quantity)="row">
                            <span
                              v-if="totalInventoryQuantity(row.item) > 0"
                              class="font-weight-bold"
                              >{{
                                convertPrice(totalInventoryQuantity(row.item))
                              }}</span
                            >
                            <span
                              v-else
                              class="text-danger font-weight-bold"
                              v-b-tooltip.hover
                              title="Kho này chưa được chia số lượng — click vào dòng để chia hàng"
                            >
                              <i class="fas fa-exclamation-circle"></i> Chưa
                              chia
                            </span>
                          </template>
                          <template v-slot:cell(detail)="row">
                            <b-button
                              size="sm"
                              variant="outline-primary"
                              @click.stop="showModalShareGoods(row.item)"
                              v-b-tooltip.hover
                              title="Mở popup chia hàng cho kho này"
                            >
                              <i class="fa fa-shopping-cart"></i>
                            </b-button>
                          </template>
                          <template v-slot:cell(actions)="row">
                            <v-icon
                              small
                              class="text-danger"
                              @click.stop="showDeleteAlert(row.item)"
                              v-b-tooltip
                              title="Xóa"
                              >mdi-delete</v-icon
                            >
                          </template>
                        </b-table>
                        <template
                          v-if="
                            mainModel &&
                            mainModel.status ===
                              PURCHASE_ORDER_STATUS.ACCOUNTANT
                          "
                        >
                          <hr
                            class="hr-text"
                            data-content="Phiếu nhập xuất kho"
                            style="font-weight: 600"
                          />
                          <POStockSlipTransaction
                            :purchase-order-id="mainModel.id"
                            mode="aggregate"
                          />
                          <hr
                            class="hr-text"
                            data-content="Bút toán"
                            style="font-weight: 600"
                          />
                          <POTransactionPanel
                            :purchase-order-id="mainModel.id"
                            mode="aggregate"
                          />
                        </template>
                        <hr
                          class="hr-text"
                          data-content="Lý do hủy phiếu"
                          style="font-weight: 600"
                        />
                        <b-row v-if="mainModel.code">
                          <b-col md="12" lg="12" sm="12">
                            <CancelReason :stockCode="mainModel.code" />
                          </b-col>
                        </b-row>

                        <div class="col-md-12" style="padding-left: 0px">
                          <div class="mb-5 mt-5">
                            <b-button
                              v-if="checkEdit()"
                              v-bind:style="btnCreate"
                              size="sm"
                              variant="primary"
                              class="font-weight-bolder mr-4"
                              @click="onSubmit"
                            >
                              Lưu
                            </b-button>
                            <b-button
                              v-bind:style="btnCreate"
                              size="sm"
                              variant="secondary"
                              class="font-weight-bolder"
                              @click="onBack"
                            >
                              Hủy
                            </b-button>
                          </div>
                          <b-modal
                            v-model="showProviderModal"
                            hide-footer
                            title="Thêm mới nhà cung cấp"
                          >
                            <b-row class="mb-5">
                              <b-col>
                                <label class="labelInput"
                                  >Tên nhà cung cấp:</label
                                >
                                <b-form-input
                                  v-model="providerName"
                                  size="sm"
                                  placeholder="Nhập tên nhà cung cấp"
                                ></b-form-input>
                              </b-col>
                              <b-col>
                                <label class="labelInput"
                                  >Số điện thoại nhà cung cấp:</label
                                >
                                <b-form-input
                                  v-model="providerPhone"
                                  size="sm"
                                  placeholder="Nhập số điện thoại nhà cung cấp"
                                ></b-form-input>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                <b-button
                                  style="font-weight: 600; width: 70px"
                                  variant="primary"
                                  size="sm"
                                  @click="createProvider()"
                                  >Lưu</b-button
                                >
                                <b-button
                                  @click="
                                    showProviderModal = !showProviderModal
                                  "
                                  style="
                                    margin-left: 10px;
                                    font-weight: 600;
                                    width: 70px;
                                  "
                                  variant="secondary"
                                  size="sm"
                                  >Hủy</b-button
                                >
                              </b-col>
                            </b-row>
                          </b-modal>
                          <ImportProductPOShareModal
                            ref="stock-slip-excel"
                            v-on:validData="validData"
                          />
                          <ShareGoods
                            ref="share-goods-modal"
                            v-on:onSubmit="onSubmitShareGoods"
                            :editable="true"
                          />
                          <CancelPO
                            ref="po-cancel"
                            :purchaseOrderCode="mainModel.code"
                            :purchaseOrderId="mainModel.id"
                            :purchaseOrderStatus="mainModel.status"
                            v-on:onSuccess="onCancelSuccess"
                          />
                        </div>
                      </div>

                      <div
                        class="py-4 mb-5 full-width"
                        data-wizard-type="step-content"
                      >
                        <div class="col-12">
                          <UploadFile
                            v-if="mainModel.id"
                            :id="mainModel.id"
                            :entity="'purchase-orders'"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end: Wizard Nav -->
        </b-card>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTUtil from '@/assets/js/components/util';
import KTWizard from '@/assets/js/components/wizard';
import PurchaseOrderShareService from '@/core/api/purchase-order/purchase-order-share.service';
import PurchaseOrderService from '@/core/api/purchase-order/purchase-order.service';
import { PurchaseOrderShareModel } from '@/core/models/PurchaseOrderShare.model';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { convertToNumber } from '@/utils/common';
import { showConfirmDialog } from '@/utils/sweet-alert2';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { permissionMixin } from '@/view/mixins/permission.mixins';
import swalMixin from '@/view/mixins/toast.mixins';
import UploadFile from '@/view/modules/upload/Upload';
import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import decounce from 'debounce';
import { reduce, reject, sumBy } from 'lodash';
import moment from 'moment';
import Swal from 'sweetalert2';
import { v4 } from 'uuid';
import { validationMixin } from 'vuelidate';
import {
  convertPrice,
  currencyMask,
  formatDate,
  makeToastFaile,
  makeToastSuccess,
  unMaskPrice,
  xoa_dau,
} from '../../../utils/common';
import { PURCHASE_ORDER_TYPE, TIME_TRIGGER } from '../../../utils/constants';
import { getCurrentDate } from '../../../utils/date';
import {
  API_RESPONSE_STATUS,
  DISCOUNT_TYPE,
  PERMISSIONS,
  PRODUCT_TYPE_ENUM,
  PURCHASE_ORDER_STATUS,
} from '../../../utils/enum';
import fileDownload from '../../../utils/file-download';
import POStockSlipTransaction from '../../components/purchase-orders/POStockSlipTransaction.vue';
import POTransactionPanel from '../../components/purchase-orders/POTransactionPanel.vue';
import POVat from '../../components/purchase-orders/POVat';
import ShareGoods from '../../components/purchase-orders/ShareGoods';
import CancelPO from '../../components/stock-slips/CancelPO';
import CancelReason from '../../components/stock-slips/CancelReason';
import ImportProductPOShareModal from '../../components/purchase-orders/ImportProductPOShareModal';

export default {
  mixins: [validationMixin, swalMixin, permissionMixin],
  data() {
    return {
      btnCreate: {
        fontWeight: '600!important',
        'margin-right': '-10px',
        width: '70px',
      },
      isSubmitting: false,
      searchProduct: '',
      listTypeSearch: [
        {
          id: null,
          name: 'Tất cả loại sản phẩm',
        },
      ],
      selectTypeSearch: null,
      listProduct: [],
      inputSearchProductProp: {
        class: 'autosuggest__input',
        placeholder: 'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
        style: 'border-radius:0px!important',
        disabled: true,
      },
      formater: {
        currency: currencyMask,
      },
      showProviderModal: false,
      providerName: '',
      providerPhone: '',
      filteredOptionsProvider: [],
      optionsProvider: [],
      isSearching: false,
      inputPropStore: {
        class: 'autosuggest__input',
        placeholder: 'Chọn kho',
        style: 'border-radius:0px!important',
        disabled: false,
      },
      listAmountType: [
        { id: DISCOUNT_TYPE.AMOUNT, name: 'Tiền mặt' },
        { id: DISCOUNT_TYPE.PERCENT, name: '%' },
      ],
      fieldProduct: [
        {
          key: 'productName',
          label: 'Sản phẩm',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '25%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'inStockQuantity',
          label: 'Tồn',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-right',
        },
        {
          key: 'prevUnitPrice',
          label: 'Giá nhấp nhất',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
        {
          key: 'salePowerWeek',
          label: 'Sức bán tuần',
          thStyle: { fontWeight: 600, color: '#181c32', width: '7%' },
          tdClass: 'text-right',
        },
        {
          key: 'salePowerMonth',
          label: 'Sức bán tháng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '7%' },
          tdClass: 'text-right',
        },
        {
          key: 'quantity',
          label: 'Số lượng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '6%' },
          tdClass: 'text-right',
        },
        {
          key: 'unitPrice',
          label: 'Đơn giá (VAT)',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
        },
        {
          key: 'totalAmount',
          label: 'Thành tiền',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
          formatter: (_, __, item) => {
            if (!item) {
              return 0;
            }
            const totalAmount =
              unMaskPrice(item.quantity) * unMaskPrice(item.unitPrice);
            return convertPrice(totalAmount);
          },
        },
        {
          key: 'salePrice',
          label: 'Đơn giá bán',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
      ],
      renderComponent: true,
      mainModel: {
        id: null,
        code: '',
        status: 1,
        providerId: null,
        providerName: '',
        description: '',
        storeId: null,
        discountValue: 0,
        discountType: DISCOUNT_TYPE.AMOUNT,
        vatValue: 0,
        vatType: DISCOUNT_TYPE.PERCENT,
        payDate: null,
        vatCode: '',
        vatSerial: '',
        vatDate: '',
        createdAt: '',
        createdBy: '',
        type: 1,
        importReason: '',
        isNew: true,
        isVAT: true,
      },
      PURCHASE_ORDER_STATUS: PURCHASE_ORDER_STATUS,
      PERMISSIONS: PERMISSIONS,
      API_RESPONSE_STATUS: API_RESPONSE_STATUS,
      PRODUCT_TYPE_ENUM,
      listImportType: PURCHASE_ORDER_TYPE,
      hashName: null,
      filteredOptionsEmployee: [],
      optionsEmployee: [],
      searchEmployee: '',
      selectedProducts: [],
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
      stores: [],
      selectedStores: [],
      fieldStores: [
        {
          key: 'name',
          label: 'Kho',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '50%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'quantity',
          label: 'Tổng SL',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-right',
          formatter: (_, __, item) => {
            if (!item) {
              return 0;
            }
            const totalQuantity = sumBy(item.products, 'quantity');
            return totalQuantity ? convertPrice(totalQuantity) : 0;
          },
        },
        {
          key: 'totalAmount',
          label: 'Tổng tiền',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-right',
          formatter: (_, __, item) => {
            if (!item) {
              return 0;
            }
            const totalAmount = this.calTotalAmountProducts(item.products);
            return convertPrice(totalAmount);
          },
        },
        {
          key: 'detail',
          label: 'Chia hàng',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-center',
        },
        {
          key: 'actions',
          label: '',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-center',
        },
      ],
      inventories: [],
      isError: false,
    };
  },
  components: {
    KTCodePreview,
    ImportProductPOShareModal,
    POStockSlipTransaction,
    POTransactionPanel,
    CancelReason,
    CancelPO,
    Treeselect,
    POVat,
    Autosuggest,
    ShareGoods,
    UploadFile,
  },
  created() {
    this.fetchStore();
    this.fetchProvider();
    this.getListEmployee();
  },
  async mounted() {
    this.mainModel.createdAt = getCurrentDate();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu yêu cầu nhập hàng', route: '/purchase-orders' },
      { title: 'Thông tin phiếu PO chia hàng' },
    ]);
    if (this.$route.query.id) {
      this.mainModel.id = this.$route.query.id;
      this.mainModel.isNew = !!this.$route.query.isCreate;
      // Đảm bảo optionsEmployee có trước khi hydrate detail để resolve inChargeEmployeeName.
      await this.getListEmployee();
      this.loadDetail(this.mainModel.id);
    } else {
      if (!this.fieldProduct.find((f) => f.key === 'actions')) {
        this.fieldProduct.push({
          key: 'actions',
          label: '',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-center',
        });
      }
    }
    // Initialize form wizard
    const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : '';

    this.hashName = hashName === 'attach' ? 'attach' : null;

    const wizard = new KTWizard('kt_wizard_v4', {
      startStep: hashName === 'attach' ? 3 : 1, // initial active step number
      clickableSteps: true, // allow step clicking
    });

    wizard.on('beforeNext', function (/*wizardObj*/) {});

    wizard.on('change', function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  computed: {
    canInsert() {
      return this.hasPermission(this.PERMISSIONS.PO_INSERT);
    },
    canUpdate() {
      return this.hasPermission(this.PERMISSIONS.PO_UPDATE);
    },
    canPurchaseApprove() {
      return this.hasPermission(this.PERMISSIONS.PO_PURCHASE_APPROVE);
    },
    canAccountApprove() {
      return this.hasPermission(this.PERMISSIONS.PO_ACCOUNT_APPROVE);
    },
    canCancelPerm() {
      return this.hasPermission(this.PERMISSIONS.PO_CANCEL);
    },
    isLocked() {
      return this.mainModel.status === this.PURCHASE_ORDER_STATUS.ACCOUNTANT;
    },
    canSwitchReady() {
      return (
        this.canUpdate &&
        !!this.mainModel.id &&
        this.mainModel.status === this.PURCHASE_ORDER_STATUS.NEW
      );
    },
    canSwitchPurchased() {
      return (
        this.canPurchaseApprove &&
        !!this.mainModel.id &&
        this.mainModel.status === this.PURCHASE_ORDER_STATUS.READY
      );
    },
    canSwitchAccountant() {
      return (
        this.canAccountApprove &&
        !!this.mainModel.id &&
        this.mainModel.status === this.PURCHASE_ORDER_STATUS.PURCHASED
      );
    },
    canCancel() {
      const s = this.mainModel.status;
      return (
        this.canCancelPerm &&
        !!this.mainModel.id &&
        s !== this.PURCHASE_ORDER_STATUS.ACCOUNTANT &&
        s !== this.PURCHASE_ORDER_STATUS.CANCELED
      );
    },
    totalPrice() {
      let total = 0;
      for (let index = 0; index < this.listProduct.length; index++) {
        const element = this.listProduct[index];
        total +=
          unMaskPrice(element.unitPrice) * unMaskPrice(element.quantity) -
          unMaskPrice(element.discountAmount);
      }

      const discountValue = this.mainModel.discountValue
        ? unMaskPrice(this.mainModel.discountValue)
        : 0;
      let discountAmount = discountValue;
      if (this.mainModel.discountType === DISCOUNT_TYPE.PERCENT) {
        discountAmount = (discountValue * total) / 100;
      }

      total = total - discountAmount;
      const vatValue = this.mainModel.vatValue
        ? unMaskPrice(this.mainModel.vatValue)
        : 0;

      let vatAmount = vatValue;
      if (this.mainModel.vatType === DISCOUNT_TYPE.PERCENT) {
        vatAmount = (vatValue * total) / 100;
      }

      total = parseInt(total) + parseInt(vatAmount);
      return total;
    },
    editable() {
      // BE share update() chỉ chấp nhận status === NEW (xem
      // purchase-order-share.service.ts:286). Các status PO_HEAD_CANCEL/
      // ACCOUNTANT_CANCEL không tồn tại trong enum — đã loại bỏ.
      return this.mainModel.status === PURCHASE_ORDER_STATUS.NEW;
    },
  },
  methods: {
    showConfirmDialog,
    convertPrice,
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    onSelectedProduct() {
      // min-price deferred to P5
    },
    onInputChangProduct(text) {
      if (!text) {
        text = '';
      }
      this.searchProduct = text;
      this.debounceInputProduct();
    },
    onSubmit: async function () {
      if (
        !this.mainModel.providerName ||
        !this.mainModel.providerName.trim().length
      ) {
        this.mainModel.providerId = null;
      }
      if (!this.mainModel.providerId) {
        makeToastFaile('Vui lòng chọn nhà cung cấp!');
        return;
      }

      if (!this.listProduct || !this.listProduct.length) {
        makeToastFaile('Vui lòng nhập sản phẩm!');
        return;
      }

      const inventoryItems = this.genInventory();
      const missingProducts = this.listProduct.filter((product) => {
        const productId = String(product.productId);
        return !inventoryItems.some((inv) =>
          inv.products.some(
            (p) => String(p.productId) === productId && p.quantity > 0,
          ),
        );
      });

      if (missingProducts.length > 0) {
        const names = missingProducts
          .map((p) => p.productCode || p.productName)
          .join(', ');
        makeToastFaile(`Vui lòng phân bổ số lượng cho sản phẩm: ${names}`);
        return;
      }

      await this.saveShare();
    },
    // Chuẩn hoá form → payload theo cấu trúc BE /purchase-order/share
    buildSharePayload() {
      const inventoryItems = this.genInventory();

      // Xây dựng details có allocations từ inventories
      const details = this.listProduct
        .map((element) => {
          const allocations = [];
          inventoryItems.forEach((inventory) => {
            const found = inventory.products.find(
              (p) => p.productId === element.productId,
            );
            if (found && found.quantity > 0) {
              allocations.push({
                storeId: inventory.storeId,
                quantity: convertToNumber({
                  value: unMaskPrice(found.quantity),
                }),
              });
            }
          });

          if (!allocations.length) return null;

          return {
            productId: element.productId,
            unitPrice: element.unitPrice ? unMaskPrice(element.unitPrice) : 0,
            discountAmount: element.discountAmount
              ? unMaskPrice(element.discountAmount)
              : 0,
            beforeVatPrice: element.beforeVatPrice
              ? unMaskPrice(element.beforeVatPrice)
              : 0,
            prevUnitPrice: element.prevUnitPrice
              ? Number(element.prevUnitPrice)
              : 0,
            salePowerWeek: Number(element.salePowerWeek) || 0,
            salePowerMonth: Number(element.salePowerMonth) || 0,
            salePrice: element.salePrice ? unMaskPrice(element.salePrice) : 0,
            allocations,
          };
        })
        .filter(Boolean);

      return {
        providerId: this.mainModel.providerId,
        type: this.mainModel.type || null,
        description: this.mainModel.description,
        importReason: this.mainModel.importReason,
        inChargeEmployeeId: this.selectedEmployee || null,
        vatType: this.mainModel.vatType || null,
        vatValue: this.mainModel.vatValue
          ? unMaskPrice(this.mainModel.vatValue)
          : 0,
        vatCode: this.mainModel.vatCode || null,
        vatSerial: this.mainModel.vatSerial || null,
        vatDate: (() => {
          if (!this.mainModel.vatDate) return null;
          // Parse đa format (strict 1 format trước đó làm value bị null).
          const d = moment(this.mainModel.vatDate, [
            'DD/MM/YYYY',
            'YYYY-MM-DD',
            moment.ISO_8601,
          ]);
          return d.isValid() ? d.format('YYYY-MM-DD') : null;
        })(),
        discountType: this.mainModel.discountType || null,
        discountValue: this.mainModel.discountValue
          ? unMaskPrice(this.mainModel.discountValue)
          : 0,
        payDate: (() => {
          if (!this.mainModel.payDate) return null;
          // Parse đa format (strict 'DD/MM/YYYY' trước đó làm payDate bị null).
          const d = moment(this.mainModel.payDate, [
            'DD/MM/YYYY',
            'YYYY-MM-DD',
            moment.ISO_8601,
          ]);
          return d.isValid() ? d.format('YYYY-MM-DD') : null;
        })(),
        // BE DTO @IsBoolean() reject number — ép boolean để chắc chắn
        isVAT: Boolean(this.mainModel.isVAT),
        details,
      };
    },
    async saveShare() {
      if (this.isLocked) return;
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.isError = false;
      const inventoryItems = this.genInventory();
      await this.checkStoreEmpty(inventoryItems);
      if (this.isError) {
        // Reset cờ để các lần Submit sau không bị chặn (tránh "form không phản hồi").
        this.isSubmitting = false;
        return;
      }

      const payload = this.buildSharePayload();
      try {
        const res = this.mainModel.id
          ? await PurchaseOrderShareService.update(this.mainModel.id, payload)
          : await PurchaseOrderShareService.create(payload);
        if (res?.data?.status === this.API_RESPONSE_STATUS.SUCCESS) {
          makeToastSuccess(
            res.data.message ||
              (this.mainModel.id
                ? 'Cập nhật thành công'
                : 'Tạo phiếu thành công'),
          );
          // Lưu thành công → quay về danh sách PO (không ở lại form).
          this.$router.push({ name: 'list-purchase-orders' });
        } else {
          makeToastFaile(res?.data?.message || 'Không lưu được phiếu');
        }
      } catch (e) {
        makeToastFaile(e?.response?.data?.message || 'Có lỗi xảy ra');
      } finally {
        this.isSubmitting = false;
      }
    },
    async fetchStore() {
      try {
        const { data } = await ApiService.get('stores?getFull=true');
        // BE trả array trực tiếp khi getFull=true. Wrap với Array.isArray cho safe.
        this.stores = Array.isArray(data.data) ? data.data : [];
      } catch {
        this.stores = [];
      }
    },
    async fetchProvider() {
      try {
        const { data } = await ApiService.get(`providers/getAll`);
        // BE XMĐ trả array trực tiếp (D-Core legacy trả {providers: [...]})
        const providers = Array.isArray(data.data)
          ? data.data
          : data.data?.providers || [];
        this.optionsProvider = providers.map((element) => ({
          id: element.id,
          name: element.name,
          suggestionName: element.name,
          numPaymentDate: element.numPaymentDate,
        }));
        this.filteredOptionsProvider = [...this.optionsProvider];
      } catch {
        this.optionsProvider = [];
        this.filteredOptionsProvider = [];
      }
    },
    async fetchProduct(textSearch) {
      this.isSearching = true;

      const params = {
        storeId: this.mainModel.storeId,
        productName: textSearch,
        isCheckStock: 0,
      };

      try {
        const { data } = await ApiService.query('products/search', { params });
        return data.data || [];
      } catch {
        return [];
      }
    },
    deleteItemInArray(productId) {
      for (var i = 0; i < this.listProduct.length; i++) {
        if (this.listProduct[i].productId === productId) {
          this.listProduct.splice(i, 1);
        }
      }
      for (let index = 0; index < this.inventories.length; index++) {
        const inventory = this.inventories[index];
        inventory.products = reject(inventory.products, (product) => {
          return Number(product.productId) === Number(productId);
        });
      }
      this.calQuantityProduct();
    },
    onSelectedProvider(option) {
      this.mainModel.providerName = option.item.name;
      this.mainModel.providerId = option.item.id;
      const numDate = option.item.numPaymentDate;
      if (numDate > 0) {
        this.mainModel.payDate = moment()
          .add(numDate, 'days')
          .format('DD/MM/YYYY');
      }
      if (!numDate) {
        this.mainModel.payDate = '';
      }
    },
    onInputChangeProvider(text) {
      this.mainModel.providerName = text;
      const filteredData = this.optionsProvider
        .filter((item) => {
          return item.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
        })
        .slice(0, this.limit);
      this.filteredOptionsProvider = [...filteredData];
    },
    createProvider: async function () {
      if (!this.providerName) {
        return;
      }

      const data = {
        name: this.providerName,
        phoneNo: this.providerPhone,
        status: 1,
      };

      try {
        const response = await ApiService.post('providers', data);
        const { status, message } = response.data.data;
        if (status === 1) {
          this.fetchProvider();
          this.showProviderModal = !this.showProviderModal;
          makeToastSuccess(message);
        } else {
          this.showProviderModal = !this.showProviderModal;
          makeToastFaile(message);
        }
      } catch (err) {
        makeToastFaile(err?.response?.data?.message || 'Có lỗi xảy ra');
      }
    },
    searchProductAPI() {
      if (!this.isSearching) {
        const textSearch = this.searchProduct;
        this.fetchProduct(textSearch);
      }
    },
    debounceInputProduct: decounce(function () {
      this.searchProductAPI();
    }, TIME_TRIGGER),
    showModalImportProduct() {
      this.$refs['stock-slip-excel'].showModal();
    },
    validData(data) {
      // ImportProductPOModal emit mảng phẳng SP đã enrich. PO chia hàng không
      // gắn 1 kho — SL phân bổ về từng kho qua grid "Danh sách chia hàng" sau,
      // nên import chỉ nạp danh sách SP (quantity=0), bỏ trùng theo productId.
      const existingIds = new Set(this.listProduct.map((p) => p.productId));
      const newProducts = (data || [])
        .filter((it) => !existingIds.has(it.productId))
        .map((it) => ({
          ...it,
          productId: it.productId,
          id: v4(),
          quantity: 0,
          quantityApprove: 0,
          totalAmount: 0,
          isNew: true,
        }));
      if (!newProducts.length) return;

      this.listProduct = this.listProduct.concat(newProducts);
      // Nếu đã có kho trong danh sách chia hàng → thêm SP mới vào từng kho (SL 0).
      if (this.inventories.length) {
        this.inventories.forEach((inventory) => {
          const invProducts = newProducts.map((p) => ({ ...p, id: v4() }));
          inventory.products = invProducts.concat(inventory.products);
        });
      }
      this.calQuantityProduct();
    },
    onBack() {
      this.$router.push({
        name: 'list-purchase-orders',
      });
    },
    // --- Workflow buttons (Cha) ---
    async onSwitchReady() {
      const r = await this.popupSwalWarning({
        title: 'Gửi duyệt phiếu?',
        text: 'Hành động này sẽ cascade xuống toàn bộ phiếu Con.',
      });
      if (!r.value) return;
      await this._callWorkflow(
        () => PurchaseOrderService.switchReady(this.mainModel.id),
        'Đã gửi duyệt',
      );
    },
    async onSwitchPurchased() {
      const r = await this.popupSwalWarning({
        title: 'Trưởng ngành hàng duyệt phiếu?',
        text: 'Hệ thống sẽ chốt số lượng duyệt theo grid hiện tại. Cascade xuống Con.',
      });
      if (!r.value) return;
      const items = (this.listProduct || [])
        .map((p) => ({
          detailId: Number(p.id) > 0 ? Number(p.id) : null,
          quantityApprove: Number(p.quantityApprove ?? p.quantity ?? 0),
        }))
        .filter((i) => i.detailId != null);
      await this._callWorkflow(
        () =>
          PurchaseOrderService.switchPurchased(this.mainModel.id, { items }),
        'Đã duyệt cấp Ngành hàng',
      );
    },
    async onSwitchAccountant() {
      const r = await this.popupSwalWarning({
        title: 'Kế toán duyệt phiếu?',
        text: `Phiếu sẽ bị khoá sau khi duyệt, bút toán tương ứng cho từng kho con. Tiếp tục?`,
      });
      if (!r.value) return;
      await this._callWorkflow(
        () => PurchaseOrderService.switchAccountant(this.mainModel.id, {}),
        'Đã duyệt cấp Kế toán',
      );
    },
    onCancel() {
      // Dùng CancelPO modal (cùng pattern List.vue + Info.vue) để có 2
      // dropdown Loại trả phiếu + Lý do hủy. Payload đầy đủ qua component.
      this.$refs['po-cancel'].showModal();
    },
    async onCancelSuccess() {
      makeToastSuccess('Đã huỷ phiếu');
      await this.loadDetail(this.mainModel.id);
    },
    async _callWorkflow(fn, successMsg) {
      try {
        const { data } = await fn();
        if (data.status === this.API_RESPONSE_STATUS.SUCCESS) {
          makeToastSuccess(successMsg);
          // BE workflow API (switchReady/switchPurchased/switchAccountant/
          // cancel) trả PurchaseOrder entity dạng single (qua detail()), KHÔNG
          // có shape children[]/inventories của PO Share. Re-fetch qua Share
          // service để hydrate đúng → các computed (canSwitchReady,
          // canSwitchPurchased...) react theo status mới, button cập nhật.
          await this.loadDetail(this.mainModel.id);
        } else {
          makeToastFaile(data.message || 'Có lỗi xảy ra');
        }
      } catch (err) {
        makeToastFaile(err?.response?.data?.message || 'Có lỗi xảy ra');
      }
    },
    async loadDetail(id) {
      try {
        const res = await PurchaseOrderShareService.getById(id);
        if (res?.data?.status === this.API_RESPONSE_STATUS.SUCCESS) {
          const data = res.data.data;
          this._applyDetailToForm(data);
        } else {
          makeToastFaile(res?.data?.message || 'Không tải được phiếu');
        }
      } catch (e) {
        makeToastFaile(e?.response?.data?.message || 'Có lỗi xảy ra');
      }
    },
    // Hydrate response /purchase-order/share/:id qua PurchaseOrderShareModel.
    // BE eager-load `provider`, `createdByUser`, `details[].product`, `children[].store`,
    // `children[].details[].product` — model expose flat field cho view binding.
    _applyDetailToForm(data) {
      const model = PurchaseOrderShareModel.fromJson(data);

      // Header field 1-1 với model — spread vào mainModel.
      Object.assign(this.mainModel, {
        status: model.status || 1,
        code: model.code || '',
        description: model.description || '',
        importReason: model.importReason || '',
        storeId: model.storeId || null,
        providerName: model.providerName,
        providerId: model.providerId || null,
        createdBy: model.createdByName,
        isVAT: Boolean(model.isVAT),
        vatCode: model.vatCode || '',
        vatSerial: model.vatSerial || '',
        type: model.type || 1,
        // UI bind trực tiếp BE field — input user nhập vào discountValue/vatValue
        // (có thể là % hoặc tiền tuỳ discountType/vatType).
        discountValue: model.discountValue || 0,
        vatValue: model.vatValue || 0,
        discountType: model.discountType || DISCOUNT_TYPE.AMOUNT,
        vatType: model.vatType || DISCOUNT_TYPE.PERCENT,
        // Field cần transform format.
        createdAt: formatDate(model.createdAt, 'HH:mm:ss DD/MM/YYYY'),
        payDate: formatDate(model.payDate, 'DD/MM/YYYY'),
        vatDate: formatDate(model.vatDate, 'DD/MM/YYYY'),
      });

      // BE chưa eager-load employee → resolve name từ list đã fetch.
      this.selectedEmployee = model.inChargeEmployeeId || null;
      const emp = this.optionsEmployee.find(
        (e) => e.id === model.inChargeEmployeeId,
      );
      this.searchEmployee = emp ? emp.name : '';

      this.inputSearchProductProp.disabled = false;

      // listProduct: tận dụng PurchaseOrderDetailModel đã hydrate flat fields.
      // Chỉ thêm `isNew` + override totalAmount theo công thức UI.
      this.listProduct = (model.details || []).map((d) => ({
        ...d,
        totalAmount: d.quantity * d.unitPrice - d.discountAmount,
        isNew: false,
      }));

      // inventories: derived từ children[] (xem PurchaseOrderShareModel)
      this.inventories = (model.inventories || []).map((inv) => ({ ...inv }));

      if (this.mainModel.isNew) {
        // Copy mode — reset id để force tạo mới
        this.mainModel.id = null;
        this.mainModel.status = PURCHASE_ORDER_STATUS.NEW;
      }

      if (this.mainModel.status === PURCHASE_ORDER_STATUS.NEW) {
        if (!this.fieldProduct.find((f) => f.key === 'actions')) {
          this.fieldProduct.push({
            key: 'actions',
            label: '',
            thStyle: {
              fontWeight: 600,
              color: '#181c32',
              textAlign: 'center',
              width: '5%',
            },
            tdClass: 'text-center',
          });
        }
      }

      this.onChangeVat();
    },
    onInputChangeEmployee(text) {
      if (!text) {
        text = '';
      }
      this.searchEmployee = text;
      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.optionsEmployee
        .filter((item) => {
          const nameNoneSign = xoa_dau(item.name);
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            nameNoneSign.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, this.limit);

      this.filteredOptionsEmployee = [...filteredData];
    },
    onSelectedEmployee(option) {
      this.searchEmployee = option.item.name;
      this.selectedEmployee = option.item.id;
    },
    async getListEmployee() {
      // XMĐ chưa có endpoint employees/getAll — dùng users/select (BE: getFull=true).
      try {
        const response = await ApiService.query('users/select', {
          params: { getFull: true },
        });
        const employees = response.data.data || [];
        this.optionsEmployee = employees.map((element) => ({
          id: element.id,
          name: element.fullName,
          suggestionName: element.fullName,
        }));
      } catch {
        this.optionsEmployee = [];
      }
    },
    checkEdit() {
      // BE share update() chỉ chấp nhận status === NEW.
      return this.mainModel.status === PURCHASE_ORDER_STATUS.NEW;
    },
    async loadOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const result = await this.fetchProduct(searchQuery);
        // BE products/search trả Product entity raw — field name khớp entity
        // (id/name/code/type), không phải D-Core legacy (productId/productName/...).
        const options = (result || []).map((element) => {
          const unitPrice = element.importPrice || 0;
          return {
            id: element.id,
            label: element.name,
            customLabel: '',
            productName: element.name,
            productCode: element.code,
            // Sức bán: khởi tạo 0, fetch thực qua getPowerSaleByProductIds khi thêm vào lưới.
            salePowerWeek: 0,
            salePowerMonth: 0,
            prevUnitPrice: 0,
            unitPrice,
            quantity: 0,
            quantityApprove: 0,
            discountAmount: 0,
            totalAmount: unitPrice,
            // PO Share không gắn 1 kho → tổng tồn tất cả store
            inStockQuantity: (element.productStock || []).reduce(
              (sum, s) => sum + (s.inStockQuantity || 0),
              0,
            ),
            salePrice: element.sellingPrice || 0,
            productType: element.type,
          };
        });
        callback(null, options);
      }
    },
    async onAddProduct() {
      if (!this.selectedProducts || !this.selectedProducts.length) {
        return makeToastFaile('Vui lòng chọn sản phẩm muốn thêm!');
      }

      const isService = this.selectedProducts
        .map((product) => product.productType)
        .includes(PRODUCT_TYPE_ENUM.SERVICE);

      if (isService) {
        return makeToastFaile('Không hỗ trợ nhập kho sản phẩm dịch vụ');
      }

      let isValidProduct = true;
      this.selectedProducts.forEach((product) => {
        const existedProduct = this.listProduct.find(
          (pro) => pro.productId === product.id,
        );
        if (existedProduct) {
          isValidProduct = false;
          return makeToastFaile(
            ` Sản phẩm ${product.productName} đã tồn tại trong danh sách!`,
          );
        }
      });
      if (!isValidProduct) {
        return;
      }

      const products = this.selectedProducts.map((product) => {
        return {
          ...product,
          productId: product.id,
          id: v4(),
          isNew: true,
        };
      });

      this.listProduct = products.concat(this.listProduct);

      // Tính sức bán thực cho SP vừa thêm (thay cho giá trị khởi tạo 0 ở loadOptions).
      await this.getPowerSaleByProductIds(products.map((p) => p.productId));

      if (this.inventories.length) {
        this.inventories.forEach((inventory) => {
          const inventoryProducts = products.map((product) => {
            return {
              ...product,
              id: v4(),
            };
          });
          inventory.products = inventoryProducts.concat(inventory.products);
        });
      }

      this.selectedProducts = [];
    },
    // PO Share không gắn 1 kho → sức bán tổng hợp toàn hệ thống (bỏ storeId).
    async getPowerSaleByProductIds(productIds) {
      if (!productIds || !productIds.length) return;
      try {
        const { data } = await PurchaseOrderService.getPowerSale({
          productIds,
        });
        if (data.status === this.API_RESPONSE_STATUS.SUCCESS) {
          const items = data.data || [];
          items.forEach((item) => {
            const row = this.listProduct.find(
              (p) => p.productId === item.productId,
            );
            if (row) {
              row.salePowerWeek = item.salePowerWeek;
              row.salePowerMonth = item.salePowerMonth;
            }
          });
        }
      } catch {
        // fail-safe: sức bán không cập nhật được, không block UI
      }
    },
    reportClick: async function () {
      try {
        const response = await PurchaseOrderService.exportExcelDetail(
          this.mainModel.id,
        );
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
      } catch (err) {
        makeToastFaile(err?.response?.data?.message || 'Không xuất được Excel');
      }
    },
    onChangeVat() {
      const vatTableField = this.fieldProduct.find(
        (field) => field.key === 'unitPrice',
      );
      if (vatTableField) {
        vatTableField.label = this.mainModel.isVAT
          ? 'Đơn giá (VAT)'
          : 'Đơn giá';
      }
    },
    onAddStore() {
      const selectedStoreIds = this.selectedStores.map((store) => store.id);
      const existedProduct = this.inventories.find((inventory) =>
        selectedStoreIds.includes(inventory.storeId),
      );
      if (existedProduct) {
        return makeToastFaile('Kho hàng đã tồn tại trong danh sách!');
      }
      const stores = this.selectedStores.map((store) => {
        const inventoryProducts = this.listProduct.map((product) => {
          return {
            ...product,
            quantity: 0,
          };
        });

        return {
          storeId: store.id,
          name: store.name,
          shortName: store.shortName,
          id: v4(),
          products: inventoryProducts,
        };
      });

      this.inventories = stores.concat(this.inventories);

      this.selectedStores = [];
    },
    showDeleteAlert: async function (item) {
      const result = await Swal.fire({
        title: 'Xóa kho hàng!',
        text: 'Bạn có chắc muốn xóa kho hàng này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
        position: 'top',
      });
      if (result.isConfirmed) {
        this.inventories = reject(this.inventories, (inventory) => {
          return inventory.id === item.id;
        });
        this.calQuantityProduct();
      }
    },
    showModalShareGoods(item) {
      this.$refs['share-goods-modal'].showModal(
        item.id,
        item.name,
        item.products,
      );
    },
    onSubmitShareGoods(resultData) {
      const inventoryFound = this.inventories.find(
        (inventory) => inventory.id === resultData.inventoryId,
      );
      if (!inventoryFound) {
        return;
      }
      inventoryFound.products = resultData.products;
      this.calQuantityProduct();
    },
    // P6 UX: tổng SL đã chia của 1 kho — dùng để hiện badge "Chưa chia" + style row.
    totalInventoryQuantity(inventory) {
      if (!inventory || !inventory.products) return 0;
      return sumBy(
        inventory.products,
        (p) => Number(unMaskPrice(p.quantity)) || 0,
      );
    },
    // P6 UX: row đỏ nhạt nếu kho chưa được chia; click row mở modal chia hàng.
    inventoryRowClass(item) {
      if (!item) return '';
      return this.totalInventoryQuantity(item) > 0 ? '' : 'inventory-row-empty';
    },
    onInventoryRowClicked(item) {
      // Skip khi locked (status ACCOUNTANT) — không cho user thay đổi chia hàng.
      if (this.isLocked) return;
      this.showModalShareGoods(item);
    },
    calQuantityProduct() {
      const allProducts = reduce(
        this.inventories,
        function (flattened, other) {
          return flattened.concat(other.products);
        },
        [],
      );
      this.listProduct.forEach((product) => {
        const groupProducts = allProducts.filter(
          (pro) => pro.productId === product.productId,
        );
        product.quantity = sumBy(groupProducts, 'quantity');
        product.quantityApprove = sumBy(groupProducts, 'quantity');
      });
    },
    calTotalAmountProducts(products) {
      let totalAmountOfProducts = 0;
      products.forEach(({ productId, quantity = 0 }) => {
        const productFound = this.listProduct.find(
          (product) => product.productId === productId,
        );
        const unitPrice = productFound ? productFound.unitPrice : 0;
        totalAmountOfProducts += unMaskPrice(unitPrice) * unMaskPrice(quantity);
      });
      return totalAmountOfProducts;
    },
    genInventory() {
      return this.inventories.map((inventory) => {
        const inventoryProducts = [];
        inventory.products.forEach((product) => {
          const quantity = convertToNumber({
            value: unMaskPrice(product.quantity),
          });
          if (quantity > 0) {
            inventoryProducts.push({
              productId: product.productId,
              quantity,
            });
          }
        });
        return {
          id: inventory.id,
          name: inventory.name,
          storeId: inventory.storeId,
          products: inventoryProducts,
          shortName: inventory.shortName,
        };
      });
    },
    async checkStoreEmpty(inventoryItems) {
      const findEmptyProd = inventoryItems.find(
        (item) => !item.products || !item.products.length,
      );
      if (!findEmptyProd) return;
      try {
        this.isError = true;
        const title = `Cửa hàng ${findEmptyProd.name} không có sản phẩm!`;
        const desc = 'Xoá cửa hàng khỏi danh sách chia hàng';
        await showConfirmDialog(title, desc);
        this.inventories = this.inventories.filter(
          (item) => item.storeId !== findEmptyProd.storeId,
        );
        this.isError = false;
        makeToastSuccess('Cập nhật thành công');
      } catch (err) {
        console.error('checkStoreEmpty err::: ', err);
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}

/* P6 UX: highlight row trong bảng chia hàng để rõ ràng clickable + cảnh báo. */
.inventory-table tbody tr {
  cursor: pointer;
}
.inventory-table tbody tr.inventory-row-empty {
  background-color: #fff5f5;
}
.inventory-table tbody tr.inventory-row-empty:hover {
  background-color: #fed7d7;
}
</style>
